import { clientOnly$, serverOnly$ } from "vite-env-only/macros";

import { UNKNOWN } from "~/constants";

import type { LogData } from "./logging";

/**
 * An error observer that only runs server-side.
 */
function observeServerError(error: Error, data?: LogData) {
  return serverOnly$((error: Error, data?: LogData) => {
    import("newrelic")
      .then((newrelic) => {
        newrelic.default.noticeError(error, data);
      })
      .catch((error) => {
        console.error(error);
      });
  })?.apply(null, [error, data]);
}

/**
 * An error observer that only runs client-side.
 */
function observeClientError(error: Error, data?: LogData) {
  return clientOnly$((error: Error, data?: LogData) => {
    const customAttributes = {
      ...(data ?? {}),
      message: error.message,
      webViewVersion:
        globalThis.window.BibleProjectApp?.webViewVersion ?? UNKNOWN,
    };

    globalThis.window.newrelic?.noticeError(error, customAttributes);
  })?.apply(null, [error, data]);
}

/**
 * Logs an error to the appropriate system.
 */
export function observeError(error: Error, data?: LogData) {
  try {
    if (observeServerError) {
      observeServerError(error, data);
    }

    if (observeClientError) {
      observeClientError(error, data);
    }
  } catch (error) {
    console.error(error);
  }
}
